import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import { CardDetailsSection } from "./CardDetailsSection";
import { CardHeader } from "./CardHeader";
import { FileSection } from "./FileSection";
import { CardAlert } from "./CardAlert";
import Spinner from "@/components/Spinner";
import { useContractorPanelCardQuery } from "../hooks";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";
import { Module } from "@/constants";
import { ContractorPanelCardService } from "../services/contractorPanelCardService";
import { useCardFileUpload } from "../shared/hooks/useCardFileUpload";

export const ContractorPanelCardDirectory = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { contractorCardId } = useParams<{ contractorCardId: string }>();
  const { can_update } = useModulePermissions(Module.ContractorPanelCards);

  const { contractorCard, isLoading } =
    useContractorPanelCardQuery(contractorCardId);

  const {
    pendingFile,
    isUploading,
    isDragging,
    dragHandlers,
    handleFileChange,
    handleViewFile,
    handleConfirmSend,
    clearPendingFile,
    previewDialog,
    handleClosePreview,
  } = useCardFileUpload({
    cardId: contractorCard?.id,
    cardS3Key: contractorCard?.card_s3_key,
    queryKey: Module.ContractorPanelCards,
    patchCard: (cardId, data) => ContractorPanelCardService.patch(cardId, data),
  });

  if (isLoading)
    return (
      <Spinner
        className="h-screen w-screen"
        label={t("contractorCards.loading")}
      />
    );
  if (!contractorCard)
    return <CardAlert message={t("contractorCards.errors.noCardFound")} />;

  return (
    <div className="p-4 pb-20">
      <CardHeader
        projectName={contractorCard.project_name}
        storeName={contractorCard.store_name}
        onBack={() => navigate(-1)}
      />

      <CardDetailsSection contractorCard={contractorCard} />

      <FileSection
        pendingFile={pendingFile}
        savedFilename={contractorCard.card_filename}
        savedMimetype={contractorCard.card_mimetype}
        savedS3Key={contractorCard.card_s3_key}
        can_update={can_update}
        isDragging={isDragging}
        isUploading={isUploading}
        dragHandlers={dragHandlers}
        onViewFile={handleViewFile}
        onCancelPending={clearPendingFile}
        onFileChange={handleFileChange}
        onConfirmSend={handleConfirmSend}
        previewDialog={previewDialog}
        onClosePreview={handleClosePreview}
      />
    </div>
  );
};
